let tempId = 0
const clientTempId = (prefix) => {
  const prefixWithSeparator = prefix ? `${prefix}::` : ''
  return `${prefixWithSeparator}${Date.now()}-${tempId++}-tmp`
}
export default clientTempId
